(function () {
  // append button
  document
  .querySelectorAll(
    ".wp-block-post-navigation-link>a,.wp-block-query-pagination-previous,.wp-block-query-pagination-next"
  )
  .forEach((element) => {
    element.classList.add('btn','btn-circle-small');
    element.insertAdjacentHTML("beforeend", '<i class="icon-arrow"></i>');
  });
  document.querySelectorAll(".wp-block-query-pagination-numbers>*")
  .forEach((element) => {
    element.classList.add('btn','btn-circle-small');
  });
  document.querySelectorAll(".post-navigation-link-next,.wp-block-query-pagination-next")
  .forEach((element) => {element.classList.add('is-btn-reverse');
  });
})();
